import { useEffect, useState } from "react";
import { Add, Remove, Close } from "@material-ui/icons";
import "./pos.css";
import { useDispatch, useSelector } from "react-redux";
import { getProducts } from "../../redux/apiCalls";
import { userRequest } from "../../requestMethods";
import { publicRequest } from "../../requestMethods";
import styled from "styled-components";
import { addProduct, clearCart, addQuantityIcon, removeProduct } from "../../redux/cartRedux";
import Select from "react-select";
import createCustomerInvoice from "../../components/pdf/createCustomerInvoice";
import { applySst } from "../../helpers/sst";
import SstIncludedField, { CartSstLine } from "./SstIncludedField";

const ModalContainer = styled.div`
    height: 100%;
    width: 100%;
    opacity: 0.75;
    background: black;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    z-index: 10;
`;

const OverlayContainer = styled.div`
    overflow: hidden;
`;

const Overlay = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    color: white;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    top: 0;
    background-color: rgba(white, 0.5);
    visibility: visible;

    @media (max-width: 768px) {
        align-items: flex-start;
        padding-top: 5vh;
        padding-bottom: 5vh;
        box-sizing: border-box;
    }
`;

const ModalDetails = styled.div`
    background-color: rgba(white, 0.5);
    color: black;
    height: 100%;
    width: 50%;
    display: flex;
    z-index: 102;

    @media (max-width: 768px) {
        width: 95%;
        max-width: 95%;
        height: 90vh;
        max-height: 90vh;
        border-radius: 10px;
        overflow: hidden;
    }
`;

const EmptyModalDetails = styled.div`
    background-color: rgba(white, 0.5);
    color: black;
    height: 100%;
    width: 50%;
    display: flex;
    z-index: 102;

    @media (max-width: 768px) {
        width: 5%;
        min-width: 0;
    }
`;

const ModalItemContainer = styled.div`
    background-color: white;
    color: black;
    height: 100%;
    width: 100%;
    display: grid;
    position: relative;

    @media (max-width: 768px) {
        height: 100%;
        max-height: 100%;
        overflow: hidden;
    }
`;

const ColorPickerContainer = styled.div`
    overflow-y: auto;
    overflow-x: hidden;
    height: 100vh;
    display: grid;
    grid-template-columns: auto;
    padding: 0 4rem;
    z-index: 101;
    background: rgb(240, 240, 255);

    @media (max-width: 768px) {
        height: 100%;
        max-height: 100%;
        grid-template-columns: 1fr;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        padding: 24px 10px 10px;
        box-sizing: border-box;
    }
`;

const MobileCloseButton = styled.button`
    display: none;

    @media (max-width: 768px) {
        display: flex;
        position: absolute;
        top: 12px;
        left: 12px;
        z-index: 103;
        background: rgba(0, 0, 0, 0.6);
        color: white;
        border: none;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 0;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
        transition: background 0.2s;

        &:hover {
            background: rgba(0, 0, 0, 0.8);
        }

        &:active {
            background: rgba(0, 0, 0, 0.9);
        }
    }
`;

const defaultPosInputs = {
    isProduct: true,
    discount: 0,
    deposit: 0,
    mileage: "",
    vehicle: undefined,
    country: "",
    remark: "",
    affiliateCode: "",
    kwp: "",
    createdAt: undefined,
    sstIncluded: false,
};

export default function Pos() {
    const dispatch = useDispatch();
    const products = useSelector((state) => state.product.products);
    const [colorpicker, setColorPicker] = useState(false);
    const [cashierMode, setCashierMode] = useState("sales");
    const [vehiclesData, setVehiclesData] = useState([]);
    const [inputs, setInputs] = useState(defaultPosInputs);
    const [resetKey, setResetKey] = useState(0);
    const [itemDetails, setItemDetails] = useState({
        name: undefined,
        price: undefined,
        type: "new",
    });

    const [product, setProduct] = useState({});
    const [color, setColor] = useState({});
    const [filterList, setFilterList] = useState({
        type: "watch",
    });
    // eslint-disable-next-line
    const [productfilterCategory, setProductFilterCategory] = useState({
        status: "active",
        model: undefined,
        brand: undefined,
        name: "",
    });

    // eslint-disable-next-line
    const [quantity, setQuantity] = useState(1);

    const cart = useSelector((state) =>
        state.cart ? state.cart.products : []
    );

    const principle = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.principle : null
    );

    const currentUser = useSelector((state) => state.user.currentUser);

    const NumberFormatter = new Intl.NumberFormat("en-GB", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const total = useSelector((state) =>
        state.cart ? (state.cart.total ? state.cart.total : 0) : 0
    );

    const cartTotalDue = () => {
        const afterDiscount = total - (Number(inputs.discount) || 0);
        return applySst(afterDiscount, undefined, inputs.sstIncluded === true);
    };

    // Custom sort order for products
    const productOrder = ['Jinko Panel', 'Module Bificial Dual Glass', 'Inverter', 'Warranty', 'Equipment', 'Others', 'Add On'];
    
    const sortedProducts = products ? [...products].sort((a, b) => {
        const indexA = productOrder.indexOf(a.title);
        const indexB = productOrder.indexOf(b.title);
        
        // If product is not in the order list, put it at the end
        const orderA = indexA === -1 ? productOrder.length : indexA;
        const orderB = indexB === -1 ? productOrder.length : indexB;
        
        return orderA - orderB;
    }) : [];

    let deconstructedProductList = [];
    cart.forEach((product) => {
        for (let i = 0; i < product.quantity; i++) {
            deconstructedProductList.push(product);
        }
    });

    useEffect(() => {
        if (colorpicker === true) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [colorpicker]);

    useEffect(() => {
        if (vehiclesData[0] === undefined) {
            getVehicles();
        }
    }, [vehiclesData, dispatch]);

    useEffect(() => {
        getProducts(dispatch, productfilterCategory);
    }, [dispatch, filterList, productfilterCategory]);

    const getVehicles = async () => {
        const res = await publicRequest.get("/users/all", {
            params: {},
        });
        setVehiclesData(res.data);
    };

    const handleChange = (e) => {
        setInputs((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };

    const handleSetItemDetails = (e) => {
        setItemDetails((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };

    const handleInputVehicle = (e) => {
        const value = e.target ? e.target.value : e.value;
        setInputs((prev) => {
            return { ...prev, vehicle: value };
        });
    };

    const handleMileage = (e) => {
        setInputs((prev) => {
            return { ...prev, mileage: e.target.value };
        });
    };

    const handleQuantity = (
        product,
        quantity,
        amount,
        myAmount,
        activeColor
    ) => {
        dispatch(
            addQuantityIcon({
                ...product,
                quantity,
                amount,
                myAmount,
                activeColor,
            })
        );
    };

    const handleRemoveItem = (productToRemove, index) => {
        dispatch(
            removeProduct({
                index: index
            })
        );
    };

    const handlePosCreateOrder = async () => {
        let paymentproof = undefined;
        if (cart.length === 0) {
            alert("No product added!!");
            return;
        }

        if (total - inputs.discount < 0) {
            alert("Total cannot be a negative number");
            return;
        }

        if (inputs.vehicle === undefined) {
            alert("Please select a customer first");
            return;
        }

        if (currentUser) {
            try {
                const res = await userRequest.post("/orders/pos", {
                    userId: inputs.vehicle,
                    inputs,
                    products: cart.map((item) => ({
                        productId: item._id,
                        quantity: item.amount,
                        code: item.title,
                        img: item.img,
                        price: item.price,
                        amount: item.amount,
                        type: item.type,
                        itemCode: item.itemCode,
                        system: item.system,
                    })),
                    amount: total,
                    address: "-",
                    isProduct: inputs.isProduct,
                    createdBy: currentUser ? currentUser._id : undefined,
                    salesperson: currentUser._id,
                    deposit: inputs.deposit !== undefined && inputs.deposit !== "" ? Number(inputs.deposit) : undefined,
                    affiliateCode: inputs.affiliateCode,
                    tradein: undefined,
                    paymentproof: paymentproof,
                    kwp: inputs.kwp,
                    country: inputs.country,
                    remark: inputs.remark,
                    createdAt: inputs.createdAt,
                });

                if (res.data) {
                    alert("Your order has been completed");
                    createCustomerInvoice(res.data);
                    dispatch(clearCart());
                    setTimeout(() => {
                        window.location.pathname = "/pos";
                    }, 1000);
                } else {
                    alert("Server issue, please contact support");
                }
            } catch (err) {
                alert("Total Amount cannot be 0");
            }
        } else {
            alert("Please login before checking out");
        }
    };

    const handleClear = async () => {
        dispatch(clearCart());
        setInputs(defaultPosInputs);
        setItemDetails({
            name: undefined,
            price: undefined,
            type: "new",
        });
        setProduct({});
        setColor({});
        setFilterList({
            type: "watch",
        });
        setProductFilterCategory({
            status: "active",
            model: undefined,
            brand: undefined,
            name: "",
        });
        setCashierMode("sales");
        setColorPicker(false);
        setResetKey((prev) => prev + 1);
    };

    const handlePosDeposit = async () => {
        let totalItems = 0;
        cart.forEach((item) => {
            if (item.type === "watch") {
                totalItems = totalItems + 1 * item.quantity;
            }
        });
        if (cart.length === 0) {
            alert("No product added!!");
            return;
        }

        if (total - inputs.discount < 0) {
            alert("Total cannot be a negative number");
            return;
        }

        if (inputs.vehicle === undefined) {
            alert("Please select Number Plate first");
            return;
        }

        if (total - inputs.deposit < 0) {
            alert("Deposit cannot be more than sales total");
            return;
        }

        if (!inputs.deposit) {
            alert(
                `Deposit cannot be less than ${
                    process.env.REACT_APP_COUNTRY === "SINGAPORE" ? "$" : "RM"
                } 0.00`
            );
            return;
        }

        if (currentUser) {
            try {
                const createdBy = principle ? principle : currentUser._id;
                const res = await userRequest.post("/orders/deposit", {
                    userId: createdBy,
                    inputs,
                    products: cart.map((item) => ({
                        productId: item._id,
                        quantity: item.amount,
                        code:
                            item.brand === "HQ"
                                ? `${item.color.name}`
                                : `${item.brand}-${item.color.name}`,
                        img: item.img,
                        price: item.color.price,
                        amount: item.amount,
                        type: item.type,
                        itemCode: item.itemCode,
                    })),
                    amount: total,
                    address: "POS Sales",
                    isProduct: true,
                    cashier: currentUser ? currentUser._id : undefined,
                    mileage: inputs.mileage,
                });

                if (res.data) {
                    alert("Your deposit has been completed");
                    dispatch(clearCart());
                } else {
                    alert("Server issue, please contact support");
                }
            } catch (err) {
                alert("Failed to create deposit, please check with admin");
            }
        } else {
            alert("Please login before checking out");
        }
    };

    const handleAddProduct = (product, color, quantity) => {
        try {
            dispatch(
                addProduct({
                    ...product,
                    activeColor: color ? color : itemDetails,
                    quantity,
                })
            );
        } catch {}
    };

    return (
        <div className="pos" key={resetKey}>
            <div className="userContainer">
                <div className="checkoutButtons">
                    <div
                        className="salesButton lightyellow"
                        onClick={() => setCashierMode("sales")}
                    >
                        Sales
                    </div>
                </div>
                <div className="calculator">
                    <div className="cartContainer">
                        <div className="cartTitle">Service</div>

                        <div className="cartTitle">Quantity</div>
                        <div className="cartTitle">Total Price</div>
                    </div>
                    {cart ? (
                        cart.map((product, i) => (
                            <div className="cartContainer" key={i}>
                                <div className="cartItem capitalize">
                                    {product.title || product.color?.name || "Product"}
                                </div>
                                <div className="quantityItem">
                                    <Add
                                        style={{ fontSize: "0.8rem" }}
                                        onClick={() =>
                                            handleQuantity(
                                                product,
                                                1,
                                                product.amount + 1,
                                                product.price,
                                                product.color
                                            )
                                        }
                                    />
                                    {product.amount}
                                    <Remove
                                        style={{ fontSize: "0.8rem", cursor: "pointer" }}
                                        onClick={() => handleRemoveItem(product, i)}
                                    />
                                </div>
                                <div className="cartItem">
                                    {process.env.REACT_APP_COUNTRY ===
                                    "SINGAPORE"
                                        ? "$"
                                        : "RM"}
                                    {(product.price * product.amount).toFixed(2)}
                                </div>
                            </div>
                        ))
                    ) : (
                        <></>
                    )}
                </div>
                <div className="summary">
                    <div className="summarysubtotal">SubTotal </div>
                    <div className="summarysubtotal">
                        {process.env.REACT_APP_COUNTRY === "SINGAPORE"
                            ? "$"
                            : "RM"}
                        {total ? NumberFormatter.format(total) : "0"}
                    </div>
                </div>

                <div className="summary depositPadding">
                    <div className="addDiscountItem">
                        <div className="summarysubtotal">Discount</div>
                        <input
                            name="discount"
                            type="number"
                            onChange={handleChange}
                            defaultValue={""}
                        />
                    </div>
                </div>

                <CartSstLine
                    sstIncluded={inputs.sstIncluded}
                    afterDiscount={total - (Number(inputs.discount) || 0)}
                />

                {cashierMode === "sales" && (
                    <>
                        <div className="summary totalButton">
                            <div className="summarysubtotal">Total </div>
                            <div className="summarysubtotal">
                                {process.env.REACT_APP_COUNTRY === "SINGAPORE"
                                    ? "$"
                                    : "RM"}
                                {NumberFormatter.format(cartTotalDue())}
                            </div>
                        </div>

                        {/* <div
                            className="summary totalButton pointer lightblue"
                            onClick={() => handleWhatsapp()}
                        >
                            Whatsapp
                        </div> */}
                    </>
                )}

                {cashierMode === "deposit" && (
                    <>
                        <div className="summary depositPadding">
                            <div className="addDiscountItem">
                                <div className="summarysubtotal">Deposit</div>
                                <input
                                    name="deposit"
                                    type="number"
                                    onChange={handleChange}
                                    defaultValue={""}
                                />
                            </div>
                        </div>
                        <div className="summary totalButton">
                            <div className="summarysubtotal">Remaining </div>
                            <div className="summarysubtotal">
                                {process.env.REACT_APP_COUNTRY === "SINGAPORE"
                                    ? "$"
                                    : "RM"}
                                {NumberFormatter.format(
                                    cartTotalDue() -
                                        (Number(inputs.deposit) || 0)
                                )}
                            </div>
                        </div>
                        <div className="usersummaryContainer">
                            <div className="addProductItem fullWidth">
                                <label>Vehicle</label>
                                <Select
                                    options={vehiclesData.map((user, i) => {
                                        return {
                                            label: `${user.plate}-${user.user.phoneNumber}-${user.user.name}`,
                                            value: user._id,
                                        };
                                    })}
                                    onChange={handleInputVehicle}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            padding: '4px',
                                            border: '1px solid #ccc',
                                            borderRadius: '6px',
                                            fontSize: '17px',
                                            fontFamily: 'FuturaPT-Book',
                                            background: 'white',
                                            boxShadow: 'none',
                                            minHeight: '44px',
                                            '&:hover': {
                                                borderColor: '#ccc',
                                            }
                                        }),
                                        valueContainer: (base) => ({
                                            ...base,
                                            padding: '0 8px',
                                        }),
                                        input: (base) => ({
                                            ...base,
                                            margin: '0',
                                            padding: '0',
                                        }),
                                        placeholder: (base) => ({
                                            ...base,
                                            fontFamily: 'FuturaPT-Book',
                                        }),
                                        singleValue: (base) => ({
                                            ...base,
                                            fontFamily: 'FuturaPT-Book',
                                        }),
                                    }}
                                />
                            </div>

                            <div className="addProductItem fullWidth">
                                <label>Mileage</label>
                                <input
                                    name="mileage"
                                    type="string"
                                    onChange={handleMileage}
                                    defaultValue={""}
                                />
                            </div>
                        </div>
                        <div className="">
                            <div
                                className="salesButton deposit"
                                onClick={handlePosDeposit}
                            >
                                Deposit{" "}
                            </div>
                        </div>
                    </>
                )}
                <div className="possummaryContainer">
                    <div className="addProductItem fullWidth">
                        <label>Date of Issue</label>
                        <input
                            type="date"
                            onChange={(e) =>
                                setInputs((prev) => ({
                                    ...prev,
                                    createdAt: new Date(
                                        e.target.value
                                    ).toISOString(),
                                }))
                            }
                        />
                    </div>
                    <div className="addProductItem fullWidth">
                        <label>Customer</label>
                        <Select
                            options={vehiclesData.map((user, i) => {
                                return {
                                    label: `${user.phoneNumber}-${user.name}`,
                                    value: user._id,
                                };
                            })}
                            onChange={handleInputVehicle}
                            placeholder="Select Customer"
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    padding: '0',
                                    border: '1px solid #ccc',
                                    borderRadius: '6px',
                                    fontSize: '17px',
                                    fontFamily: 'FuturaPT-Book',
                                    background: 'white',
                                    boxShadow: 'none',
                                    minHeight: '44px',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        borderColor: '#ccc',
                                    }
                                }),
                                valueContainer: (base) => ({
                                    ...base,
                                    padding: '12px',
                                }),
                                input: (base) => ({
                                    ...base,
                                    margin: '0',
                                    padding: '0',
                                }),
                                placeholder: (base) => ({
                                    ...base,
                                    fontFamily: 'FuturaPT-Book',
                                    fontSize: '17px',
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    fontFamily: 'FuturaPT-Book',
                                    fontSize: '17px',
                                }),
                                indicatorSeparator: () => ({
                                    display: 'none',
                                }),
                                dropdownIndicator: (base) => ({
                                    ...base,
                                    padding: '8px',
                                }),
                            }}
                        />
                    </div>

                    <div className="addProductItem fullWidth">
                        <label>Deposit</label>
                        <input
                            name="deposit"
                            type="number"
                            placeholder="Enter deposit amount"
                            value={inputs.deposit ?? ""}
                            onChange={handleChange}
                            min={0}
                            step="0.01"
                            style={{
                                padding: "12px",
                                border: "1px solid #ccc",
                                borderRadius: "6px",
                                fontSize: "17px",
                                fontFamily: "FuturaPT-Book",
                                background: "white",
                                width: "100%",
                                boxSizing: "border-box",
                            }}
                        />
                    </div>
                    <SstIncludedField
                        sstIncluded={inputs.sstIncluded}
                        onChange={(value) =>
                            setInputs((prev) => ({
                                ...prev,
                                sstIncluded: value,
                            }))
                        }
                        afterDiscount={total - (Number(inputs.discount) || 0)}
                    />
                    <div className="addProductItem fullWidth">
                        <label>Remark (Optional)</label>
                        <textarea
                            placeholder="Remark"
                            rows={5}
                            style={{ padding: "10px", resize: "vertical" }}
                            onChange={(e) =>
                                setInputs((prev) => ({
                                    ...prev,
                                    remark: e.target.value,
                                }))
                            }
                        />
                    </div>
                </div>
                <div className="checkoutButtons">
                    <div
                        className="salesButton sales"
                        onClick={handlePosCreateOrder}
                    >
                        Sales{" "}
                    </div>
                </div>

                <div className="checkoutButtons">
                    <div className="salesButton reset" onClick={handleClear}>
                        Full Reset
                    </div>
                </div>
            </div>

            {colorpicker && (
                <OverlayContainer>
                    <ModalContainer></ModalContainer>
                    <Overlay>
                        <EmptyModalDetails
                            onClick={() => setColorPicker(false)}
                        ></EmptyModalDetails>
                        <ModalDetails>
                            <ModalItemContainer>
                                <MobileCloseButton onClick={() => setColorPicker(false)}>
                                    <Close style={{ fontSize: 14 }} />
                                </MobileCloseButton>
                                <ColorPickerContainer>
                                    <div className="itemDetailsContainer">
                                    <div className="summary" style={{ flexDirection: 'column', width: '100%', maxWidth: '100%', gap: '12px', alignItems: 'stretch', alignSelf: 'stretch', boxSizing: 'border-box', paddingLeft: 0, paddingRight: 0 }}>
                                        <div className="addProductItem fullWidth" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                                            <label>Name</label>
                                            <input
                                                name="name"
                                                type="text"
                                                placeholder="Enter name"
                                                value={itemDetails.name || ""}
                                                onChange={handleSetItemDetails}
                                                style={{
                                                    padding: '12px',
                                                    border: '1px solid #ccc',
                                                    borderRadius: '6px',
                                                    fontSize: '17px',
                                                    fontFamily: 'FuturaPT-Book',
                                                    background: 'white',
                                                    width: '100%',
                                                    boxSizing: 'border-box',
                                                }}
                                            />
                                        </div>
                                        <div className="addProductItem fullWidth" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                                            <label>Price</label>
                                            <input
                                                name="price"
                                                type="number"
                                                placeholder="Enter price"
                                                value={itemDetails.price ?? ""}
                                                onChange={handleSetItemDetails}
                                                style={{
                                                    padding: '12px',
                                                    border: '1px solid #ccc',
                                                    borderRadius: '6px',
                                                    fontSize: '17px',
                                                    fontFamily: 'FuturaPT-Book',
                                                    background: 'white',
                                                    width: '100%',
                                                    boxSizing: 'border-box',
                                                }}
                                            />
                                        </div>
                                    </div>
                                    {itemDetails.name === "Jinko Panel" && (
                                            
                                            <div className="summary">
                                                <div className="addProductItem fullWidth">
                                                    <label>System</label>
                                                    <select
                                                        name="system"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                        style={{
                                                            padding: '12px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '6px',
                                                            fontSize: '17px',
                                                            fontFamily: 'FuturaPT-Book',
                                                            background: 'white',
                                                            width: '100%',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <option value="">
                                                            Select System
                                                        </option>
                                                        <option value="NEM">
                                                            NEM
                                                        </option>
                                                        <option value="ATAP">
                                                            ATAP
                                                        </option>
                                                        <option value="SELCO">
                                                            SELCO
                                                        </option>
                                                        <option value="SELCO + ATAP">
                                                            SELCO + ATAP
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        )}
                                        <div className="summary">
                                            <div className="addProductItem fullWidth">
                                                {itemDetails.name ===
                                                    "Inverter" && (
                                                    <select
                                                        name="type"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                        style={{
                                                            padding: '12px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '6px',
                                                            fontSize: '17px',
                                                            fontFamily: 'FuturaPT-Book',
                                                            background: 'white',
                                                            width: '100%',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <option value="">
                                                            Select
                                                        </option>
                                                        <option value="Solis">
                                                            Solis
                                                        </option>
                                                        <option value="Sunglow">
                                                            Sunglow
                                                        </option>
                                                        <option value="Goodwe">
                                                            Goodwe
                                                        </option>
                                                        <option value="Huawei">
                                                            Huawei
                                                        </option>
                                                        <option value="Solax">
                                                            Solax
                                                        </option>
                                                        <option value="Hoymiles">
                                                           Hoymiles
                                                        </option>
                                                    </select>
                                                )}
                                                {itemDetails.name ===
                                                    "Jinko Panel" && (
                                                    <select
                                                        name="type"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                        style={{
                                                            padding: '12px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '6px',
                                                            fontSize: '17px',
                                                            fontFamily: 'FuturaPT-Book',
                                                            background: 'white',
                                                            width: '100%',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <option value="">
                                                            Select
                                                        </option>
                                                        <option value="Jinko Tiger Neo N-type">
                                                            Jinko Tiger Neo
                                                            N-type
                                                        </option>
                                                    </select>
                                                )}
                                                {itemDetails.name ===
                                                    "Module Bificial Dual Glass" && (
                                                    <select
                                                        name="type"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                        style={{
                                                            padding: '12px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '6px',
                                                            fontSize: '17px',
                                                            fontFamily: 'FuturaPT-Book',
                                                            background: 'white',
                                                            width: '100%',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <option value="">
                                                            Select
                                                        </option>
                                                        <option value="Module Bificial Dual Glass">
                                                            Module Bificial Dual
                                                            Glass
                                                        </option>
                                                    </select>
                                                )}
                                                {itemDetails.name ===
                                                    "Warranty" && (
                                                    <select
                                                        name="type"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                        style={{
                                                            padding: '12px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '6px',
                                                            fontSize: '17px',
                                                            fontFamily: 'FuturaPT-Book',
                                                            background: 'white',
                                                            width: '100%',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <option value="">
                                                            Select
                                                        </option>
                                                        <option value="2 years Warranty (Workmanship)">
                                                            2 years Warranty
                                                            (Workmanship)
                                                        </option>
                                                        <option value="3 years Warranty (Workmanship)">
                                                            3 years Warranty
                                                            (Workmanship)
                                                        </option>
                                                        <option value="15 years Warranty (Workmanship)">
                                                            15 years Warranty
                                                            (Workmanship)
                                                        </option>
                                                    </select>
                                                )}
                                                {itemDetails.name ===
                                                    "Add On" && (
                                                    <select
                                                        name="type"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                        style={{
                                                            padding: '12px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '6px',
                                                            fontSize: '17px',
                                                            fontFamily: 'FuturaPT-Book',
                                                            background: 'white',
                                                            width: '100%',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <option value="">
                                                            Select
                                                        </option>
                                                        <option value="Maintenance">
                                                            Maintenance
                                                        </option>
                                                        <option value="Insurance">
                                                            Insurance
                                                        </option>
                                                        <option value="Upgrade inverter">
                                                            Upgrade inverter
                                                        </option>
                                                        <option value="Balast system">
                                                            Balast system
                                                        </option>
                                                        <option value="Outstation Fee">
                                                            Outstation Fee
                                                        </option>
                                                        <option value="580W Panel">
                                                            580W Panel
                                                        </option>
                                                        <option value="590W Panel">
                                                            590W Panel
                                                        </option>
                                                        <option value="620W Panel">
                                                            620W Panel
                                                        </option>
                                                    </select>
                                                )}
                                                {itemDetails.name ===
                                                    "Others" && (
                                                    <input
                                                        type="text"
                                                        name="type"
                                                        placeholder="Enter value"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                    />
                                                )}
                                                {itemDetails.name ===
                                                    "Equipment" && (
                                                    <select
                                                        name="type"
                                                        onChange={(e) => {
                                                            const selectedOption = e.target.options[e.target.selectedIndex];
                                                            setItemDetails((prev) => ({
                                                                ...prev,
                                                                type: e.target.value,
                                                                fullTitle: selectedOption.text
                                                            }));
                                                        }}
                                                        style={{
                                                            padding: '12px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '6px',
                                                            fontSize: '17px',
                                                            fontFamily: 'FuturaPT-Book',
                                                            background: 'white',
                                                            width: '100%',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <option value="">
                                                            Select Equipment
                                                        </option>
                                                        <option value="PPS2200">
                                                            Outdoor solar powerstation+2 solar panel package
                                                        </option>
                                                        <option value="M2200">
                                                            Outdoor solar powerstation
                                                        </option>
                                                        <option value="P2200">
                                                            Expandable powerstation
                                                        </option>
                                                        <option value="PPS2200Pro">
                                                            Outdoor solar powerstation(fast charge)+2 solar panel package
                                                        </option>
                                                        <option value="S2200Pro">
                                                            Outdoor solar powerstation(fast charge)
                                                        </option>
                                                        <option value="B2200-F">
                                                            Expandable powerstation
                                                        </option>
                                                        <option value="XS500-F">
                                                            Outdoor solar powerstation
                                                        </option>
                                                        <option value="MJ-BW300C">
                                                            CCTV smart solar flood light 300W
                                                        </option>
                                                        <option value="MJ-BW500C">
                                                            CCTV smart solar flood light 500W
                                                        </option>
                                                        <option value="SP-220W">
                                                            Solar panel 220W 太阳能板
                                                        </option>
                                                        <option value="MJ-SF01">
                                                            Solar Fan太阳能风扇
                                                        </option>
                                                        <option value="MJ-EW800">
                                                            Exlorer Warrior Garden Light 800W (Primary Version)
                                                        </option>
                                                        <option value="MJ-EW1200">
                                                            Exlorer Warrior Garden Light 1200W (Primary Version)
                                                        </option>
                                                        <option value="MJ-SFL100">
                                                            Solar flood light 100W (Primary Version)
                                                        </option>
                                                        <option value="MJ-SFL200">
                                                            Solar flood light 200W (Primary Version)
                                                        </option>
                                                        <option value="MJ-SFL300">
                                                            Solar flood light 300W (Primary Version)
                                                        </option>
                                                        <option value="MJ-SFL500">
                                                            Solar flood light 500W (Primary Version)
                                                        </option>
                                                        <option value="MJ-SSO100C">
                                                            CCTV Version 100W Excluded SIM Card & TF Card
                                                        </option>
                                                        <option value="MJ-SSO200C">
                                                            CCTV Version 200W Excluded SIM Card & TF Card
                                                        </option>
                                                        <option value="MJ-SSO100">
                                                            No CCTV Version 100W Excluded SIM Card & TF Card
                                                        </option>
                                                        <option value="MJ-SSO200">
                                                            No CCTV Version 200W Excluded SIM Card & TF Card
                                                        </option>
                                                        <option value="MJ-SSTH800">
                                                            Solar Street Light Primary Version 800W
                                                        </option>
                                                        <option value="MJ-SSTH1200">
                                                            Solar Street Light Primary Version 1200W
                                                        </option>
                                                        <option value="MJ-SSL902">
                                                            Solar Street Light 200W
                                                        </option>
                                                        <option value="MJ-SSL903">
                                                            Solar Street Light 300W
                                                        </option>
                                                    </select>
                                                )}
                                            </div>
                                        </div>



                                        {itemDetails.name === "Inverter" && (
                                            <div className="summary">
                                                <div className="addProductItem fullWidth">
                                                    <label>KW</label>
                                                    <input
                                                        name="KW"
                                                        type="number"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                        defaultValue={""}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {itemDetails.name === "Inverter" && (
                                            <div className="summary">
                                                <div className="addProductItem fullWidth">
                                                    <label>Battery</label>
                                                    <select
                                                        name="battery"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                        style={{
                                                            padding: '12px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '6px',
                                                            fontSize: '17px',
                                                            fontFamily: 'FuturaPT-Book',
                                                            background: 'white',
                                                            width: '100%',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <option value="">
                                                            Select Battery
                                                        </option>
                                                        <option value="SELCO BESS BATTERY">
                                                            SELCO BESS BATTERY
                                                        </option>
                                                        <option value="HYBRID READY">
                                                            HYBRID READY
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        )}

                                        {itemDetails.name === "Jinko Panel" && (
                                            <div className="summary">
                                                <div className="addProductItem fullWidth">
                                                    <label>Phase</label>
                                                    <select
                                                        name="phase"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                        style={{
                                                            padding: '12px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '6px',
                                                            fontSize: '17px',
                                                            fontFamily: 'FuturaPT-Book',
                                                            background: 'white',
                                                            width: '100%',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <option value="">
                                                            Select Phase
                                                        </option>
                                                        <option value="Single">
                                                            Single
                                                        </option>
                                                        <option value="Three">
                                                            Three
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        )}

                                        {itemDetails.name === "Jinko Panel" && (
                                            <div className="summary">
                                                <div className="addProductItem fullWidth">
                                                    <label>Voltage</label>
                                                    <select
                                                        name="voltage"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                        style={{
                                                            padding: '12px',
                                                            border: '1px solid #ccc',
                                                            borderRadius: '6px',
                                                            fontSize: '17px',
                                                            fontFamily: 'FuturaPT-Book',
                                                            background: 'white',
                                                            width: '100%',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <option value="">
                                                            Select Voltage
                                                        </option>
                                                        <option value="580W">
                                                            580W
                                                        </option>
                                                        <option value="590W">
                                                            590W
                                                        </option>
                                                        <option value="620W">
                                                            620W
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        )}

                                        {itemDetails.name === "Jinko Panel" && (
                                            <div className="summary">
                                                <div className="addProductItem fullWidth">
                                                    <label>Quantity</label>
                                                    <input
                                                        name="quantity"
                                                        type="number"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                        defaultValue={""}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {itemDetails.name === "Jinko Panel" && (
                                            <div className="summary">
                                                <div className="addProductItem fullWidth">
                                                    <label>KWP</label>
                                                    <input
                                                        name="kwp"
                                                        type="number"
                                                        placeholder="KWP"
                                                        onChange={
                                                            handleSetItemDetails
                                                        }
                                                        defaultValue={""}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        <button
                                            className="productListEdit mt-2"
                                            onClick={() => {
                                                let updatedItemDetails = { ...itemDetails };
                                                    handleAddProduct(
                                                        product,
                                                        updatedItemDetails,
                                                        updatedItemDetails.quantity
                                                            ? updatedItemDetails.quantity
                                                            : 1
                                                    );
                                                
                                                setColorPicker(false);
                                                setItemDetails({
                                                    name: undefined,
                                                    price: undefined,
                                                    type: undefined,
                                                    quantity: undefined,
                                                    voltage: undefined,
                                                    KW: undefined,
                                                    phase: undefined,
                                                    kwp: undefined,
                                                });
                                            }}
                                        >
                                            Add To Cart
                                        </button>
                                    </div>
                                </ColorPickerContainer>
                            </ModalItemContainer>
                        </ModalDetails>
                    </Overlay>
                </OverlayContainer>
            )}
            <div className="posWrapper">
                <div className="checkoutButtons">
                    <div
                        className="salesButton lightred"
                        onClick={() => setFilterList({ type: "watch" })}
                    >
                        Select Products
                </div>
            </div>
                <div className="posContainer">
                    {" "}
                    {sortedProducts.length > 0 ? (
                        sortedProducts.map((product, i) => {
                            return (
                                <div
                                    key={i}
                                    className="posItem"
                                    onClick={() => {
                                        setColor(product.color);
                                        setProduct(product);
                                        setItemDetails({
                                            name: `${product.title}`,
                                        });
                                        window.scrollTo(0, 0);
                                        setColorPicker(true);
                                    }}
                                >
                                    <div className="productDetails">
                                        {product.title}
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <></>
                    )}
                </div>
            </div>
        </div>
    );
}
